import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_INCIDENT_REPORTS = createRequestTypes('GET_INCIDENT_REPORTS');
export const DELETE_INCIDENT_REPORTS = createRequestTypes('DELETE_INCIDENT_REPORTS');
export const SET_INCIDENT_REPORTS_PAGE = 'SET_INCIDENT_REPORTS_PAGE';
export const SET_INCIDENT_REPORTS_PAGE_SIZE = 'SET_INCIDENT_REPORTS_PAGE_SIZE';
export const SET_INCIDENT_REPORTS_TABLE_FILTER = 'SET_INCIDENT_REPORTS_TABLE_FILTER';

export const setIncidentReportsPageSize = (payload) => ({
  type: SET_INCIDENT_REPORTS_PAGE_SIZE,
  payload,
});

export const setIncidentReportsPage = (payload) => ({
  type: SET_INCIDENT_REPORTS_PAGE,
  payload,
});

export const setIncidentReportsTableFilter = (payload) => ({
  type: SET_INCIDENT_REPORTS_TABLE_FILTER,
  payload,
});

export const getIncidentReports = {
  request: (data) => action(GET_INCIDENT_REPORTS[REQUEST], { data }),
  success: (payload) => action(GET_INCIDENT_REPORTS[SUCCESS], { payload }),
  failure: (payload) => action(GET_INCIDENT_REPORTS[FAILURE], { payload }),
};

export const deleteIncidentReports = {
  request: (data) => action(DELETE_INCIDENT_REPORTS[REQUEST], { data }),
  success: (payload) => action(DELETE_INCIDENT_REPORTS[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_INCIDENT_REPORTS[FAILURE], { payload }),
};
